import { render, staticRenderFns } from "./FileWidget.vue?vue&type=template&id=0dd05112&scoped=true&"
import script from "./FileWidget.vue?vue&type=script&lang=js&"
export * from "./FileWidget.vue?vue&type=script&lang=js&"
import style0 from "./FileWidget.vue?vue&type=style&index=0&id=0dd05112&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd05112",
  null
  
)

export default component.exports